import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { nsFormFieldStyles, nsSharedStyles } from '../ns-styles/index.js';
import { depthChoiceLabel } from '../ns-relationship/relationship-terms.js';

const OFFERED_DEPTHS = 5;

@customElement('ns-depth-input')
export class NSDepthInput extends LitElement {
  @property({ type: Number })
  value = 0;

  @property({ type: String })
  label = 'How far past them do you need to see?';

  static styles = [
    nsSharedStyles,
    nsFormFieldStyles,
    css`
      :host {
        display: block;
      }
    `,
  ];

  private __onChange(evt: Event) {
    this.value = Number((evt.target as HTMLSelectElement).value);
    this.dispatchEvent(
      new CustomEvent('depth-change', { detail: { value: this.value }, bubbles: true, composed: true }),
    );
  }

  render() {
    // A deeper ask saved before the list was capped still shows as itself
    const depths = Array.from({ length: Math.max(OFFERED_DEPTHS, this.value) + 1 }, (_, depth) => depth);
    return html`
      <div class="field">
        <label for="depth">${this.label}</label>
        <select class="w-100" id="depth" aria-describedby="depth-hint" @change=${this.__onChange}>
          ${depths.map(
            (depth) => html`
              <option value=${depth} ?selected=${depth === this.value}>${depthChoiceLabel(depth)}</option>
            `,
          )}
        </select>
        <p class="hint" id="depth-hint">
          They choose which of their suppliers to share.
          <slot></slot>
        </p>
      </div>
    `;
  }
}
